import "./App.css";
import logo from "./Logo.png";
import Avatar from "./Avatar/Avatar";
import { PhoneFilled, GlobalOutlined, MailFilled } from "@ant-design/icons";

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get("dialerUrl");

  return (
    <div className="App">
      <iframe
        src={paramValue ? paramValue : "https://feavt2.dialerhosting.com/"}
        allow="camera;microphone"
        title="FE Dailer"
      />

      <div className="main-content">
        <header className="App-header">
          <p className="header-title">FE Avatar</p>
          <img src={logo} className="App-logo" alt="logo" />
          <p className="header-title">Agent Avatar</p>
        </header>

        <section className="App-content">
          <Avatar />
        </section>

        <footer className="App-footer">
          <span className="footer-item">
            <PhoneFilled />
            <a href="tel:+92-3315890467">+92-331-5890467</a>
          </span>

          <a
            href="https://technationals.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-item"
          >
            Copyright {new Date().getFullYear()} © Tech Nationals{" "}
            <GlobalOutlined />
          </a>

          <span className="footer-item">
            <a href="mailto: info@technationals.com?subject=Inventory Management Portal Inquiry">
              info@technationals.com
            </a>
            <MailFilled />
          </span>
        </footer>
      </div>
    </div>
  );
}

export default App;
